import type { CrumbData, Crumb, CrumbType, Item } from './types';

/** Permet de générer le lien associé à une entrée de fil d'Ariane */
const getCrumbLink = (type: CrumbType, { slug, enabled }: CrumbData) => {
  // Cas particuliers
  if (type === 'home') return '/';
  if (type === 'family') return null;
  if (enabled === false) return null;
  // Liens nécessitant la présence d'un slug
  if (slug == null) return null;
  if (type === 'recipe') return `/recette/${slug}`;
  if (type === 'product') return `/produit/${slug}`;
  if (type === 'category') return `/categorie/${slug}`;
  return null;
};

/** Transforme un `Item` en un `Crumb` pour utilisation dans le fil d'ariane  */
export const getCrumbFromItem = (item: Item): Crumb => {
  const type = 'slug' in item ? 'product' : 'recipe';
  const slug = 'slug' in item ? item.slug : item.activeSlug;
  const data = { id: item.id, name: item.name, slug, enabled: false };
  return getCrumb(type, data);
};

/** Retourne une entrée de fil d'ariane à partir de son type et de ses données */
export const getCrumb = (type: CrumbType, data: CrumbData): Crumb => {
  const link = getCrumbLink(type, data);
  return { id: data.id, name: data.name, type, link };
};

/**
 * Filtre les entrées problématiques du fil d'ariane :
 * - Supprime la page d'accueil lorsqu'elle est référencée comme catégorie
 * - Élimine les familles qui ne doivent pas apparaître dans le fil d'ariane pour le moment
 */
export const isValidCrumb = (item: Crumb): boolean => {
  if (item.link === '/categorie/accueil') return false;
  if (item.type === 'family') return false;
  return true;
};
